import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { PlayerItemModule } from '../../_shared/components/player-item/player-item.module';
import { EmptyPageModule } from '../../empty-page/empty-page.module';
import { TeamDetailsComponent } from './team-details.component';
import { TeamPopoverComponent } from './team-popover/team-popover.component';
import { SelectUserModule } from '../../_shared/components/select-user/select-user.module';
import { TieScorecardModule } from '../../ties/tie-details/tie-scorecard/tie-scorecard.module';
import { CreateTeamModule } from '../create-team/create-team.module';
import { TeamLineupComponent } from './team-lineup/team-lineup.component';
import { AddTemplateModule } from '../../_shared/components/add-template/add-template.module';
import { SelectTeamPlayerModule } from '../../_shared/components/select-team-player/select-team-player.module';
import { TeamScheduleComponent } from './team-schedule/team-schedule.component';
import { SeasonSelectorModule } from '../../_shared/components/season-selector/season-selector.module';
import { TeamDetailsRoutingModule } from './team-details-routing.module';
import { TeamParticipantsComponent } from './team-participants/team-participants.component';
import { TeamAdminsComponent } from './team-admins/team-admins.component';
import { TeamCoachesComponent } from './team-coaches/team-coaches.component';
import { TeamFansComponent } from './team-fans/team-fans.component';
import { ToolbarComponent } from '../../_shared/components/toolbar/toolbar.component';
import { DetailsComponent } from './details/details.component';
import { ConfirmEmailComponent } from './confirm-email/confirm-email.component';
import { TeamJoinDialogComponent } from './team-join-dialog/team-join-dialog.component';
import { StaffListComponent } from './team-admins/join/staff-list.component';
import { ParticipantsListComponent } from './team-participants/join/participants-list.component';
import { PopupCardComponent } from '../../_shared/components/popup-card/popup-card.component';
import { AddOrInvitePlayerModal } from './share-team-sheet/add-or-invite-modal.component';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild(),
        PlayerItemModule,
        EmptyPageModule,
        SelectUserModule,
        TieScorecardModule,
        CreateTeamModule,
        AddTemplateModule,
        SelectTeamPlayerModule,
        SeasonSelectorModule,
        TeamDetailsRoutingModule,
        TeamFansComponent
    ],
    declarations: [
        TeamDetailsComponent,
        TeamPopoverComponent,
        TeamLineupComponent,
        TeamScheduleComponent,
        TeamParticipantsComponent,
        TeamAdminsComponent,
        TeamCoachesComponent,
        ToolbarComponent,
        DetailsComponent,
        ConfirmEmailComponent,
        TeamJoinDialogComponent,
        StaffListComponent,
        PopupCardComponent,
        ParticipantsListComponent,
        AddOrInvitePlayerModal
    ]
})
export class TeamDetailsModule { }
